var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Telegram",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#37aee2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c8daea",
    d: "M199 404c-11 0-10-4-13-14l-32-105 245-144"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a9c9dd",
    d: "M199 404c7 0 11-4 16-8l45-43-56-34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6fbfe",
    d: "M204 319l135 99c14 9 26 4 30-14l55-258c5-22-9-32-24-25L79 245c-21 8-21 21-4 26l83 26 190-121c9-5 17-3 11 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.dcaf2b936270790bd364e3114b2ab2c6.svg";
export { ForwardRef as ReactComponent };